import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";

import { AuthenticationService } from "../services/auth.service";
import { TenantStore } from "../services/Stores/tenant.store";
import {
  catchError,
  of,
  switchMap,
  map
} from "rxjs";
import { InactivityService } from "../services/inactivity.service";

@Injectable({ providedIn: "root" })
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private tenantStore: TenantStore,
    private inactivityService: InactivityService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {

    return this.authService.checkAuth().pipe(

      switchMap((isAuthenticated) => {

        if (!isAuthenticated) {

          return this.handleNotAuthenticated(state.url);

        }

        // Usuário já pode estar em cache
        return this.authService.getMe().pipe(

          map((user) => {

            this.authService.saveCurrentUser(user);

            this.tenantStore.applyStyle();

            this.tenantStore.getTermsAndConditions();

            // Inicia monitoramento de inatividade após autenticação bem-sucedida
            this.inactivityService.startMonitoring();

            if (
              this.authService.IsHiringProcess &&
              !this.authService.isFirstAccess
            ) {

              this.router.navigate(["portal"]);

              return false;

            }

            return true;

          }),

          catchError(() => this.handleNotAuthenticated(state.url))

        );

      }),

      catchError(() => this.handleNotAuthenticated(state.url))

    );

  }

  private handleNotAuthenticated(returnUrl: string) {

    // Para o monitoramento se houver erro de autenticação
    this.inactivityService.stopMonitoring();

    this.router.navigate(
      ["/account/login"],
      {
        queryParams: { returnUrl }
      }
    );

    return of(false);

  }

}
